<script setup lang="ts">
import { useTemplateRef } from 'vue'

import { Cropper } from 'vue-advanced-cropper'

import 'vue-advanced-cropper/dist/style.css'

interface Props {
  selectedImage: string
}

const { selectedImage = '' } = defineProps<Props>()
const emit = defineEmits(['update:croppedImage', 'update:croppedImageBase64'])

const modelValue = defineModel({ type: Boolean, default: false })
const closeDialog = () => {
  modelValue.value = false
}

const cropperRef = useTemplateRef<InstanceType<typeof Cropper>>('cropperRef')

const confirmCrop = () => {
  if (cropperRef.value) {
    const result = cropperRef.value.getResult() // 使用cropper提供的getResult
    const canvas = result.canvas
    if (canvas) {
      const quality = 0.9 // 壓縮品質

      canvas.toBlob(
        (blob: Blob | null) => {
          if (blob) {
            const reader = new FileReader()
            reader.onloadend = () => {
              const base64Data = (reader.result as string).replace('data:image/jpeg;base64,', '')
              emit('update:croppedImage', URL.createObjectURL(blob)) // 生成 URL 顯示圖片
              emit('update:croppedImageBase64', base64Data)
              closeDialog()
            }
            reader.readAsDataURL(blob) // 轉換 Blob 為 base64
          }
        },
        'image/jpeg',
        quality
      )
    }
  }
}
</script>

<template>
  <el-dialog v-model="modelValue" :destroy-on-close="true" class="cropper-dialog" width="500px">
    <template #header>
      <div class="cropper-title">編輯圖片</div>
    </template>

    <div class="cropper-box">
      <Cropper ref="cropperRef" class="cropper" :src="selectedImage" :stencil-props="{ aspectRatio: 1200 / 628 }" />
    </div>

    <template #footer>
      <div class="dialog-footer">
        <BaseButton @click="closeDialog">取消</BaseButton>
        <BaseButton class="bg-app-brand-blue-500 text-white" @click="confirmCrop">儲存</BaseButton>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.cropper-dialog {
  :deep(.el-dialog__header) {
    padding: 20px 20px 10px;
  }

  :deep(.el-dialog__body) {
    padding: 20px;
    overflow: hidden;
  }

  :deep(.el-dialog__footer) {
    padding: 10px 20px 20px;
  }

  .cropper-title {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
  }

  .cropper-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    overflow: hidden;

    .cropper {
      width: 100%;
      max-width: 460px;
      height: 345px;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 12px;
  }
}
</style>
